import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';

import { APP_DEFAULT_PATH } from 'config';
import appLogo from 'assets/images/users/app-logo.png';

export default function LogoSection({ reverse, isIcon, sx, to }) {
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={to || APP_DEFAULT_PATH}
      sx={[{ display: 'inline-flex', height: 44, width: 'auto' }, ...(Array.isArray(sx) ? sx : [sx])]}
      aria-label="Logo"
    >
      <img src={appLogo} alt="App logo" style={{ display: 'block', width: 'auto', height: '100%', maxWidth: '100%' }} />
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
